<template>
  <box-model title="批发市场最新报价">
    <template v-slot:content>
      <div class="t-list">
        <div v-if="!list.length" class="no-data-sty table">暂无数据</div>
        <div v-else class="table">
          <div class="title-row flex-between">
            <div class="c-item c-title-sty width-20">品种</div>
            <div class="c-item c-title-sty width-20">批发市场</div>
            <div class="c-item c-title-sty width-13 hover-sty">
              <div class="c-content">最高价</div>
              <div class="show-txt">最高价</div>
            </div>
            <div class="c-item c-title-sty width-13 hover-sty">
              <div class="c-content">最低价</div>
              <div class="show-txt">最低价</div>
            </div>
            <div class="c-item c-title-sty width-13 hover-sty">
              <div class="c-content">大宗价</div>
              <div class="show-txt">大宗价</div>
            </div>
            <div class="c-item c-title-sty width-20 hover-sty">
              <div class="c-content">发布时间</div>
              <div class="show-txt">发布时间</div>
            </div>
          </div>
          <div v-for="(item, index) in list" :key="index" class="c-row flex-between" :class="index %2 ? 'c1' : 'c2'">
            <div class="c-item c-item-sty hover-sty width-20">
              <div class="c-content">{{ item.varietyName }}</div>
              <div class="show-txt">{{ item.varietyName }}</div>
            </div>
            <div class="c-item c-item-sty hover-sty width-20">
              <div class="c-content">{{ item.marketName }}</div>
              <div class="show-txt">{{ item.marketName }}</div>
            </div>
            <div class="c-item c-item-sty width-13">{{ item.highestPrice || '--' }}</div>
            <div class="c-item c-item-sty width-13">{{ item.minimumPrice || '--' }}</div>
            <div class="c-item c-item-sty width-13">{{ item.middlePrice || '--' }}</div>
            <div class="c-item c-item-sty hover-sty width-20">
              <div class="c-content">{{ item.reportTime }}</div>
              <div class="show-txt-1">{{ item.reportTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import { getOfferPrice } from "@/api/index"
  export default {
    data() {
      return {
        list: []
      }
    },
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted() {
      this.getOfferPriceEvent();
    },
    methods: {
      getOfferPriceEvent(){
        getOfferPrice().then((res) => {
          if(!res.data){
            this.list = [];
            return;
          }
          const result = JSON.parse(res.data) || [];
          this.list = result;
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .table {
    width: 100%;
    height: 352px;
    overflow-y: scroll;
    .title-row {
      width: 100%;
      height: 32px;
      background: rgba(9, 148, 255, .19);
    }
    .c-row {
      width: 100%;
      height: 40px;
    }
    .c1 {
      background: rgba(9, 148, 255, 0.14);
    }
    .c2 {
      background: rgb(2, 12, 31);
    }
    .c-item {
      height: 100%;
      font-size: 15px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      padding: 0 12px;
      .c-content {
        position: relative;
        z-index: 3;
        width: 100%;
        height: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 40px;
      }
      .show-txt {
        display: none;
        position: absolute;
        left: 100%;
        top: 0;
        z-index: 9;
        width: 100%;
        color: #333333;
        font-size: 15px;
        line-height: 18px;
        word-wrap: break-word;
        background: #ffffff;
        padding: 4px;
        border-radius: 4px;
      }
      .show-txt-1 {
        display: none;
        position: absolute;
        left: -100%;
        top: 0;
        z-index: 9;
        width: 110%;
        color: #333333;
        font-size: 15px;
        line-height: 18px;
        word-wrap: break-word;
        background: #ffffff;
        padding: 4px;
        border-radius: 4px;
      }
    }
    .c-ellipsis {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .c-item-sty {
      line-height: 40px;
    }
    .hover-sty {
      cursor: pointer;
      position: relative;
    }
    .hover-sty:hover .show-txt {
      display: block;
    }
    .hover-sty:hover .show-txt-1 {
      display: block;
    }
    .c-title-sty {
      color: #FFFFFF;
      font-size: 15px;
      line-height: 32px;
    }
    .width-20 {
      width: 20%;
    }
    .width-13 {
      width: 13.33%;
    }
  }
</style>